
import React, { useState,Fragment } from 'react'
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap';
import { putAPI_Invitation } from '../../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../../helpers/AxiosAPI';
const ApproveInvitation = ({ isVisible, invitation, toggle, LoadData, handleConnectedVoucher, propertyId }) => {
    let [invitationData, setInvitationData] = useState({
        'invitationId': invitation.invitationId,
        'sellerGroupId': invitation.groupId,
        'sellerPropertyId': invitation.propertyId,
        'status': '',
        'ProcessingFee': invitation.processingFee,
        'groupId': getGroupID(),
        'propertyId': propertyId,
        'sellFutureVouchers': invitation.sellFutureVouchers,
        'createdBy': 'Admin',
        'type': 'Sell',
        'relationId': invitation.relationId,
        'groups': invitation.groups,
        "propertys": invitation.propertys
    });
    const onAcceptClick = () => {
        invitationData.status = 'Accepted';
        handleInvitationApprove();
        toggle();
    };
    const onRejectClick = () => {
        invitationData.status = 'Rejected';
        AxiosAPI({
            url: `${putAPI_Invitation}`,
            method: 'put',
            data: invitationData
        }).then(res => {
            LoadData();
        });
        toggle();
    };
    const handleInvitationApprove = () => {
        AxiosAPI({
            url: `${putAPI_Invitation}`,
            method: 'put',
            data: invitationData
        }).then(res => {
            LoadData();
        })
    };
    return (
        <div>
            <Modal isOpen={isVisible} toggle={toggle} style={{ maxWidth: '35%' }}>
                <ModalHeader toggle={toggle}>
                    Approve {invitation.propertyName} to sell your voucher
                </ModalHeader>
                <ModalBody>
                    Increase your sales by launching your own beautiful voucher store
                    and let your customers purchases gift voucher directly from your website.

                    <p className='my-3'>
                       {invitation.processingFee > 0 && <Fragment>{invitation.propertyName} are showing you a comission of {invitation.processingFee}  % with you for every Sale</Fragment>}
                    </p>
                </ModalBody>
                <ModalFooter>
                    {/* <Button onClick={onRejectClick}>
                        Reject
                    </Button> */}
                    <Button color="primary" onClick={onAcceptClick}>
                        Ok
                    </Button>
                </ModalFooter>
            </Modal>

        </div >
    );
};
export default ApproveInvitation;
